import { Component } from '@angular/core';
import { environment } from '../../environments/environment';
import { CambodiaMapComponent } from '../cambodia-map/cambodia-map.component';
import { HighchartsChartComponent, HighchartsChartModule } from 'highcharts-angular';

@Component({
  selector: 'app-testing-map',
  standalone: true,
  imports: [CambodiaMapComponent],
  templateUrl: './testing-map.component.html',
  styleUrl: './testing-map.component.css'
})
export class TestingMapComponent {

  baseApiUrl = environment.baseApiUrl;

}
